<template>
  <iframe
    src="https://check-balance.s2s.ph/"
    width="100%"
    height="720"
    frameborder="0"
  ></iframe>
</template>

<script>
export default {};
</script>

<!-- <script>
import SurfLogin from "./SurfLogin.vue";
import RemainingTime from "./RemainingTime.vue";

export default {
  components: {
    SurfLogin,
    RemainingTime,
  },
  mounted() {
    if (this.page === "rates") {
      this.$store.dispatch("ADD_PAGE", null);
    }
  },
  computed: {
    path() {
      return this.$route.path;
    },
    page() {
      return this.$store.getters.GET_PAGE;
    },
  },
};
</script> -->

<style scoped></style>
